
import Vue from 'vue'
import { IFilter } from '../store/state'

// Interfaces for component typechecking!
interface FiltersProps {
	filter: IFilter
}

interface FiltersMethods {
	resetPage(): void
	setFilter(filter: IFilter): void
}

export default Vue.extend<{}, FiltersMethods, {}, FiltersProps>({
	name: 'Filters',
	props: {
		filter: {
			type: Object as () => IFilter,
			required: true
		}
	},
	methods: {
		resetPage()  {
			this.$store.commit({
				type: 'setCurrentPage',
				payload: 0
			})
		},
		setFilter(filter) {
			this.$store.dispatch({
				type: 'setFilter',
				payload: filter
			})
		}
	}
})
